import { useState } from "react";
import { LinkIcon } from "../../assets/icons/link";
import { DelinkIcon } from "../../assets/icons/delink-icon";

export default function AdsCard({ data, onClick, className }) {
  const [hover,setHover] = useState(false);
  return (
    <div className={`flex items-center justify-between border border-[#E4E4E4] bg-[#F9FAFA] rounded-lg p-4 w-full max-h-[65px] ${className}`}>
      {/* Left Section */}
      <div className="flex items-center gap-3">
        <span className="text-[#0F1114] font-semibold">{data.adFormName}</span>
        <span className="bg-[rgba(21,179,146,0.1)] text-[#15B392] border border-[#15B392] text-sm px-3 py-1 rounded-full">
          Connected
        </span>
      </div>

      {/* Right Section */}
      {/* <a className="text-teal-400 cursor-pointer" onClick={onClick} onMouseEnter={()=>{setHover(true)}} onMouseLeave={()=>setHover(false)}>
        {hover?<DelinkIcon />:<LinkIcon />}
      </a> */}
      <button className="px-5 py-1 rounded-md border primary_btn transition-all duration-500 red_btn h-[42px] text-[14px] font-mont font-[500]"  onClick={onClick} >     Disconnect</button>
    </div>
  );
}
